import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ptBRCommon from './pt-BR/common.json';
import enUSCommon from './en-US/common.json';
import esCommon from './es/common.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'en-US', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]['code'];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'pt-BR';

// Office timezone (Orlando, Florida)
export const OFFICE_TIMEZONE = 'America/New_York';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { common: ptBRCommon },
      'en-US': { common: enUSCommon },
      'es': { common: esCommon },
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
